module.exports = __webpack_public_path__ + "img/17-9.5e0c9780.jpg";